import { useApiQuery } from '@/api/hooks/useQuery';
import { campaignKeys } from '@/api/queryKeys';
import type { MagicLinkInvite } from '@/types';

/**
 * Hook to fetch magic link invite details
 * Note: This endpoint is not in the SDK, using the Api container's axios instance
 */
export function useInvite(token: string) {
  return useApiQuery<MagicLinkInvite>({
    queryKey: campaignKeys.invite(token),
    queryFn: (api) => async () => {
      const response = await api.axios.get<MagicLinkInvite>(
        `${api.basePath}/campaigns/creators/summary`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
    enabled: !!token,
  });
}
